import Loader from "components/shared/loader";
import LocalStorageService from "core/services/local-storage-service";
import queryString from "query-string";
import { useEffect, useState } from "react";

const Authenticate = ({ children }: { children: ChildNode }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const searchParams = queryString.parse(window.location.search);
    const { T: ssoToken, I: sessionId, D: expiryDate, P: currentProduct } = searchParams;
    const localStorageService = LocalStorageService.getService();

    if (ssoToken && sessionId && expiryDate) {
      localStorageService.clearCompleteStorage();

      const userData = {
        sso_token: ssoToken,
        session_id: sessionId,
        session_expiry_date: expiryDate,
        current_product: currentProduct || null,
      };

      localStorageService.setDataToLocalStorage("userData", userData);

      const timer = setTimeout(() => {
        setLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) return <Loader />;

  return children;
};

export default Authenticate;
